/*
  PDP size-chart popup.

  Opens the dialog rendered by snippets/size-chart-modal.liquid when the existing
  "Size chart" trigger next to the size selector is clicked. That trigger was
  previously an <a href="#"> with no handler at all — it looked interactive and
  did nothing.

  Document-delegated on purpose. The variant picker (and therefore the trigger
  and the dialog) is replaced wholesale when a colour swatch swaps the product,
  so binding directly to the elements would go dead after the first swap. Since
  the whole subtree is re-rendered, the swapped-in product's OWN chart comes with
  it and no re-initialisation is needed.

  Body scroll is locked while open, matching the cart drawer and mega-menu.
*/
(function () {
  var LOCK = 'diesel-size-modal-open';

  function modal() {
    return document.querySelector('[data-size-modal]');
  }

  /*
    Re-parent the dialog to <body> before showing it.

    position:fixed does NOT escape an ancestor stacking context, and this dialog
    is rendered inside the variant picker -> .product__info-wrapper, which carries
    z-index:5. The sticky header is z-index:50, so however high the dialog's own
    z-index goes it still paints UNDER the DIESEL logo -- which is exactly what
    happened: the logo covered the top corner of the open chart.

    Moving it to <body> puts it in the root stacking context, where its z-index
    finally counts. Done at open time rather than on load because the colour swap
    re-renders the picker and produces a fresh copy; any previously moved copy is
    dropped first so the two never accumulate.
  */
  function hoist(dialog) {
    if (!dialog || dialog.parentElement === document.body) return dialog;
    var stale = document.querySelectorAll('body > [data-size-modal]');
    for (var i = 0; i < stale.length; i++) stale[i].remove();
    document.body.appendChild(dialog);
    return dialog;
  }

  function open(dialog) {
    if (!dialog) return;
    dialog = hoist(dialog);
    dialog.hidden = false;
    document.documentElement.classList.add(LOCK);
    var close = dialog.querySelector('.diesel-size-modal__close');
    if (close) close.focus();
  }

  function close(dialog) {
    if (!dialog || dialog.hidden) return;
    dialog.hidden = true;
    document.documentElement.classList.remove(LOCK);
    // Return focus to whichever trigger is currently on the page.
    var trigger = document.querySelector('[data-size-chart-open]');
    if (trigger) trigger.focus();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-size-chart-open]')) {
      event.preventDefault();
      open(modal());
      return;
    }

    // The overlay and the X both carry data-size-close.
    if (target.closest('[data-size-close]')) {
      event.preventDefault();
      close(modal());
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close(modal());
  });
})();
